import { OrdersTable } from "../../orders/OrdersTable";

export const Orders = () => {
  return (
    <div className="h-full max-h-96 w-full overflow-scroll rounded-lg">
      <OrdersTable hideFilters hidePageSize limit={200} />
    </div>
  );
};

export default Orders;
